import { ButtonBase, Grid, Typography } from '@mui/material'
import styles from './GroceryListTitle.module.css'
import { CopyIcon } from '../../../iconRef/groceryListIcons'
import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../app/store/hooks'
import { GroceryList } from '../../../app/commonSelector'
import { copyToClipboard } from '../../ingredientsPage/ingredientUtils'
import { groceryListIdSelector } from '../../../app/groceryList/groceryList.slice'
import useLogRecipeEdit from '../../../hooks/useLogRecipeEdit'
import { EventLogsEnum } from '../../../utils/events'

const handleCopyIngredientToClipBoard = async (groceryIngredientList: any) => {
  const type = "text/plain";
  const ingData = groceryIngredientList.length
    ? groceryIngredientList.map((ingredient: any, index: number) => {
      const displayName = ingredient?.ingredientMetadata?.displayName;
      const amount = ingredient?.weightScaleValue.value;
      return `${index + 1}. ${displayName} --> ${amount}`;
    }).join('\n')
    : '';

  await copyToClipboard(ingData, type);
};


const GroceryListTitle = () => {
  const groceryIngredientList = useAppSelector(GroceryList);
  const groceryListId = useAppSelector(groceryListIdSelector);

  const { logRecipeEdit } = useLogRecipeEdit();



  const [copyButtonText, setCopyButtonText] = useState(`Copy Ingredients`);

  const handleCopyIngredients = async () => {
    await handleCopyIngredientToClipBoard(groceryIngredientList);
    setCopyButtonText(`Copied Ingredients`)
    const ingredientIds = groceryIngredientList?.map(groceryItem => groceryItem.ingredientId);

    logRecipeEdit(EventLogsEnum.COPY_INGREDIENTS, {
      eventData: {
        grocery_list_id: groceryListId ,
        ingredients_id_list: ingredientIds,
      },
    });
  };

  return (
    <ButtonBase className={styles.copy_button} onClick={handleCopyIngredients}>
      <CopyIcon />
      <Typography variant='ingredientText1Outfit'>{copyButtonText} ({groceryIngredientList?.length})</Typography>
    </ButtonBase>
  )
}

export default GroceryListTitle
